import { Form, Input, InputNumber, Select } from 'antd';
import { DOWN, LEFT, NEGATIVE, POSITIVE, RIGHT, UP } from './const';
import { IRule } from './type';
import { isArray } from 'radash';
import PositiveNegativeInput from './positive-negative-input';

const { Item: FormItem } = Form;
const { Item: StyleItem } = Form;

/**
 * 列定位 colum_config
 * 用于 行内容/单个单元格
 *
 * 由于ts类型一致,所以未使用泛型
 * 如果后期单独改字段等,不要再使用该组件,而是直接复制一份,防止越来越麻烦
 * TODO: 将 行定位的 类型定义定义在本组件, 通过在跟组件组合,这样就能避免类型问题
 *
 * TODO: 对于这种内部结构复杂的表单，直接封装为一个组件接收 value 和onChange，不用再内部使用多个 Form.Item
 */
const ColPosition = ({
  prefix,
  fullPrefix,
}: {
  prefix: (string | number)[];
  fullPrefix: (string | number)[];
}) => {
  const form = Form.useFormInstance();
  return (
    <>
      <FormItem
        label="列定位"
        name={[...prefix, 'colum_config', 'position_method']}
      >
        <Select
          onChange={(e, option) => {
            if (isArray(option)) {
              form.setFieldValue(
                [...fullPrefix, 'colum_config', 'offset_config'],
                undefined,
              );
              return;
            }

            const value =
              option.value as IRule['cell_content_config']['colum_config']['position_method'];

            if (value === 'ORDER') {
              // TODO 行顺序、列顺序的默认值
              form.setFieldValue(
                [...fullPrefix, 'colum_config', 'offset_config'],
                {
                  direction: 'POSITIVE',
                  offset: 1,
                },
              );
            } else if (value === 'KEYWORD') {
              form.setFieldValue(
                [...fullPrefix, 'colum_config', 'offset_config'],
                {
                  direction: 'LEFT',
                  offset: 0,
                },
              );
            }
          }}
          options={[
            {
              label: `关键词所在列`,
              value: 'KEYWORD',
            },
            {
              label: `列顺序`,
              value: 'ORDER',
            },
          ]}
        />
      </FormItem>

      {/* 列定位 关键词所在行 展示 关键词或正则表达式/偏移 */}

      {/* 列定位 行顺序 展示 正倒数 */}
      <FormItem noStyle shouldUpdate={() => true}>
        {({ getFieldValue }) => {
          const position_method = getFieldValue([
            ...fullPrefix,
            'colum_config',
            'position_method',
          ]) as IRule['col_content_config']['colum_config']['position_method'];

          // 行顺序
          if (position_method === 'ORDER') {
            return (
              <>
                <FormItem name={[...prefix, 'colum_config', 'offset_config']}>
                  <PositiveNegativeInput inputNumberProps={{ suffix: '列' }} />
                </FormItem>
                {/* <StyleItem>
                  <section className="flex gap-4">
                    <FormItem
                      className="flex-1"
                      name={[
                        ...prefix,
                        'colum_config',
                        'offset_config',
                        'direction',
                      ]}
                    >
                      <Select
                        options={[
                          {
                            label: '正数',
                            value: POSITIVE,
                          },
                          {
                            label: '倒数',
                            value: NEGATIVE,
                          },
                        ]}
                      />
                    </FormItem>
                    <FormItem
                      className="flex-2"
                      rules={[
                        {
                          required: true,
                          message: '',
                          warningOnly: true,
                          type: 'number',
                        },
                      ]}
                      name={[
                        ...prefix,
                        'colum_config',
                        'offset_config',
                        'offset',
                      ]}
                    >
                      <InputNumber
                        suffix="列"
                        className="w-full"
                        max={99999}
                        min={1}
                      />
                    </FormItem>
                  </section>
                </StyleItem> */}
              </>
            );

            // 关键词所在行
          } else if (position_method === 'KEYWORD') {
            return (
              <>
                <FormItem
                  name={[...prefix, 'colum_config', 'keyword']}
                  rules={[{ required: true, message: '', warningOnly: true }]}
                >
                  <Input allowClear placeholder="请输入关键词或正则表达式" />
                </FormItem>
                <section className="flex gap-4">
                  <FormItem
                    className="flex-1"
                    name={[
                      ...prefix,
                      'colum_config',
                      'offset_config',
                      'direction',
                    ]}
                  >
                    <Select
                      options={[
                        {
                          label: '向左偏移',
                          value: LEFT,
                        },
                        {
                          label: '向右偏移',
                          value: RIGHT,
                        },
                      ]}
                    />
                  </FormItem>
                  <FormItem
                    className="flex-2"
                    rules={[
                      {
                        required: true,
                        message: '',
                        warningOnly: true,
                        type: 'number',
                      },
                    ]}
                    name={[
                      ...prefix,
                      'colum_config',
                      'offset_config',
                      'offset',
                    ]}
                  >
                    <InputNumber
                      className="w-full"
                      max={99999}
                      min={0}
                      suffix="列"
                    />
                  </FormItem>
                </section>
              </>
            );
          }
        }}
      </FormItem>
    </>
  );
};

export default ColPosition;
